import request from '@/router/axios'

// 车辆作业看板接口
const API = '/api/produce/plc/tippler/current-plan'

function unwrap(res) {
  const body = res && res.data
  if (body && Object.prototype.hasOwnProperty.call(body, 'data')) return body.data
  return body
}

function toNumber(value) {
  if (value === null || value === undefined || value === '') return null
  const n = Number(value)
  return Number.isFinite(n) ? n : null
}

function normalizeWeighbridge(row) {
  if (!row) return null
  return {
    lineType: row.lineType,
    lineName: row.lineName,
    totalWeight: toNumber(row.totalWeight),
    carriageCount: Number(row.carriageCount || 0),
    completedCarriageCount: Number(row.completedCarriageCount || 0),
    pendingCarriageCount: Number(row.pendingCarriageCount || 0),
    time: row.time || '',
    status: row.status || 'WAITING',
    statusText: row.statusText || '等待称重'
  }
}

// 将后端当前翻车计划转换为看板展示结构
function normalizeFromApi(payload = {}) {
  const empty = {
    trainNumber: '--',
    trainStatus: 'weighing',
    weighIn: null,
    weighOut: null,
    currentDumperGroup: 1,
    minutesPerGroup: '',
    carriages: [],
    exceptions: []
  }
  const plan = payload.plan
  const list = payload.carriages || []
  if (!plan) return empty

  const weighIn = normalizeWeighbridge(payload.weighIn)
  const weighOut = normalizeWeighbridge(payload.weighOut)

  let trainStatus = 'weighing'
  if (plan.railPlanPhase === 1) trainStatus = 'dumping'
  if (plan.railPlanPhase === 2) {
    trainStatus = weighOut && weighOut.status === 'COMPLETED' ? 'completed' : 'leaving'
  }

  const carriages = list.map((item, idx) => {
    let status = 'waiting'
    if (item.tipplerStatus === 2) status = 'done'
    else if (item.tipplerStatus === 1) status = 'dumping'
    return {
      position: item.carriageSerial || idx + 1,
      model: item.carriageType || '',
      standardWeight: toNumber(item.standardWeight),
      actualWeight: toNumber(item.weightTon),
      grossWeight: toNumber(item.grossWeight),
      tareWeight: toNumber(item.tareWeight),
      status,
      carriageNumber: item.carriageNumber
    }
  })

  return {
    trainNumber: plan.trainNumber || '--',
    trainStatus,
    startTime: plan.workReadyTime || '',
    endTime: plan.lastPlcReportTime || '',
    weighIn,
    weighOut,
    currentDumperGroup: 1,
    minutesPerGroup: '',
    carriages,
    exceptions: []
  }
}

export function fetchVehicleWork(params = {}) {
  return request({ url: API, method: 'get', params })
    .then(unwrap)
    .then(normalizeFromApi)
}
